module.exports = __webpack_public_path__ + "img/5.180867d2.jpg";